import type { FC, ReactNode } from "react";
import { useEffect } from "react";

import { AnalyticsEvent, useAnalyticsLogger } from "@shared/hooks";
import { useLocation } from "@shared/react-router-dom";

import { useUnauthUrlFields } from "./useUnauthUrlFields";

interface Props {
  children: ReactNode;
  isUnauth?: boolean;
}

const PageViewLogger: FC<Props> = ({ children, isUnauth }) => {
  const { pathname } = useLocation();
  const logAnalyticsEvent = useAnalyticsLogger();
  const unauthUrlFields = useUnauthUrlFields();

  useEffect(() => {
    logAnalyticsEvent({
      eventName: isUnauth ? AnalyticsEvent.UNAUTH_PAGE_VIEW : AnalyticsEvent.STORE_PAGE_VIEW,
      payload: {
        ...unauthUrlFields,
        url: pathname,
      },
    });
  }, [pathname]);

  return <>{children}</>;
};

export { PageViewLogger };
